import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import isEqual from "lodash.isequal";
import UgCoursesList from "components/fragments/UgCoursesList";
import CustomBadge from "components/fragments/CustomBadge";
import { getShortId, scrollToTop } from "utils/generalHelpers";
import { ACTION_TYPES } from "reducers/actionTypes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "assets/stylesheets/Institutions.scss";

class Institutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeInst: null,
    };
    this.headingRef = React.createRef();
  }

  getFilteredInst = () => {
    const { institutions } = this.props;
    return institutions;
  };

  componentDidUpdate = (prevProps) => {
    const { selectedFieldOfStudy: prevFos } = prevProps;
    const { selectedFieldOfStudy } = this.props;
    if (isEqual(prevFos, selectedFieldOfStudy)) {
      return;
    } else if (!selectedFieldOfStudy) {
      return;
    } else {
      const lowerFosID = selectedFieldOfStudy.id;
      const fosID = getShortId(lowerFosID);
      this.updateInstitutionAndCourseList(fosID, lowerFosID);
      document
        .getElementById("institutions-and-courses-container")
        .scrollIntoView({ behavior: "smooth" });
      this.headingRef.current.focus({ preventScroll: true });
    }
  };

  handleClickInst = (inst) => {
    this.setState({ activeInst: inst });
  };

  updateInstitutionAndCourseList2 = (fosID) => {
    const { ug } = this.props;
    if (!ug) return;
    let courseList = [];
    const allInstKeys = [];

    ug.courses.forEach((course) => {
      if (course.fos === fosID) {
        courseList.push({
          courseCode: course.code,
          gCode: course.gCode,
          inst: course.inst,
          name: course.name,
          keywords: course.keywords,
        });
        allInstKeys.push(course.inst);
      }
    });

    // Sort courseList alphabetically by name
    courseList = courseList.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    // sort courseList by most relevant
    // let keyword = "";
    // switch (lowerFosID) {
    //   // Handle lower fos IDs
    //   case "109": // Biological Science
    //     keyword = "biology";
    //     break;
    //   case "19901": // Medical Science
    //     keyword = "medical";
    //     break;
    //   case "60301": // General Nursing
    //     keyword = "nursing";
    //     break;
    //   case "69903": // Human Movement
    //     keyword = "movement";
    //     break;
    //   case "803": // Business Management
    //     keyword = "business";
    //     break;
    //   case "909": // Law
    //     keyword = "law";
    //     break;
    //   case "91901": // Economics
    //     keyword = "economics";
    //     break;
    //   case "1007": // Communication and Media Studies
    //     keyword = "communications";
    //     break;
    //   default:
    //     break;
    // }

    // if (keyword !== "") {
    //   courseList = courseList.sort((a, b) => {
    //     if (!a.keywords || !b.keywords) {
    //       return 0;
    //     }
    //     let aPosition = a.keywords.search(keyword);
    //     let bPosition = b.keywords.search(keyword);
    //     if (aPosition > -1 && bPosition === -1) {
    //       return -1;
    //     }
    //     if (aPosition === -1 && bPosition > -1) {
    //       return 1;
    //     }
    //     return 0;
    //   });
    // }

    const uniqInstKeys = [...new Set(allInstKeys)];
    const instList = uniqInstKeys
      .map((key) => {
        return { ...ug.instMap[key], key: key };
      })
      .sort((a, b) => {
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      });
    this.props.dispatch({
      type: "UPDATE_INSTITUTIONS",
      data: { institutions: instList },
    });

    const coursesByInstitution = {};

    for (let i = 0; i < uniqInstKeys.length; i++) {
      for (let j = 0; j < courseList.length; j++) {
        if (courseList[j].inst === uniqInstKeys[i]) {
          coursesByInstitution[uniqInstKeys[i]]
            ? coursesByInstitution[uniqInstKeys[i]].push(courseList[j])
            : (coursesByInstitution[uniqInstKeys[i]] = [courseList[j]]);
        }
      }
    }

    this.props.dispatch({
      type: "UPDATE_COURSES_BY_INSTITUTION",
      data: { coursesByInstitution: coursesByInstitution },
    });
  };

  updateInstitutionAndCourseList = (fosID) => {
    const { ug } = this.props;
    if (!ug) return;
    let courseList = [];
    const allInstKeys = [];
    ug.courses.forEach((course) => {
      if (course.fos === fosID) {
        courseList.push({
          courseCode: course.code,
          gCode: course.gCode,
          inst: course.inst,
          name: course.name,
          keywords: course.keywords,
        });
        allInstKeys.push(course.inst);
      }
    });

    // Sort courseList alphabetically by name
    courseList = courseList.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    // sort courseList by most relevant
    // let keyword = "";
    // switch (lowerFosID) {
    //   // Handle lower fos IDs
    //   case "109": // Biological Science
    //     keyword = "biology";
    //     break;
    //   case "19901": // Medical Science
    //     keyword = "medical";
    //     break;
    //   case "60301": // General Nursing
    //     keyword = "nursing";
    //     break;
    //   case "69903": // Human Movement
    //     keyword = "movement";
    //     break;
    //   case "803": // Business Management
    //     keyword = "business";
    //     break;
    //   case "909": // Law
    //     keyword = "law";
    //     break;
    //   case "91901": // Economics
    //     keyword = "economics";
    //     break;
    //   case "1007": // Communication and Media Studies
    //     keyword = "communications";
    //     break;
    //   default:
    //     break;
    // }

    // if (keyword !== "") {
    //   courseList = courseList.sort((a, b) => {
    //     if (!a.keywords || !b.keywords) {
    //       return 0;
    //     }
    //     let aPosition = a.keywords.search(keyword);
    //     let bPosition = b.keywords.search(keyword);
    //     if (aPosition > -1 && bPosition === -1) {
    //       return -1;
    //     }
    //     if (aPosition === -1 && bPosition > -1) {
    //       return 1;
    //     }
    //     return 0;
    //   });
    // }

    const uniqInstKeys = [...new Set(allInstKeys)];
    const instList = uniqInstKeys
      .map((key) => {
        return { ...ug.instMap[key], key: key };
      })
      .sort((a, b) => {
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      });
    this.props.dispatch({
      type: "UPDATE_INSTITUTIONS",
      data: { institutions: instList },
    });

    const coursesByInstitution = {};

    for (let i = 0; i < uniqInstKeys.length; i++) {
      for (let j = 0; j < courseList.length; j++) {
        if (courseList[j].inst === uniqInstKeys[i]) {
          coursesByInstitution[uniqInstKeys[i]]
            ? coursesByInstitution[uniqInstKeys[i]].push(courseList[j])
            : (coursesByInstitution[uniqInstKeys[i]] = [courseList[j]]);
        }
      }
    }

    this.props.dispatch({
      type: "UPDATE_COURSES_BY_INSTITUTION",
      data: { coursesByInstitution: coursesByInstitution },
    });
  };

  handleClickStartAgain = () => {
    scrollToTop();
    const { dispatch } = this.props;
    dispatch({
      type: ACTION_TYPES.state.reset,
    });
    dispatch({
      type: ACTION_TYPES.subjects.reset,
    });
    dispatch({ type: ACTION_TYPES.atar.reset });
    dispatch({ type: ACTION_TYPES.fields.reset });
    dispatch({ type: ACTION_TYPES.selectedFieldOfStudy.reset });
  };

  render() {
    const { selectedFieldOfStudy, institutions } = this.props;
    if (!selectedFieldOfStudy) return null;

    const filteredInst = this.getFilteredInst();
    const { activeInst } = this.state;
    return (
      <div id="institutions-and-courses-container">
        <div className="section" id="institutions-container">
          <div className="section-heading-container">
            <h2
              className="major-heading"
              tabIndex={0}
              aria-label={`Institutions offering courses in this field ${institutions.length} institutions`}
              ref={this.headingRef}
            >
              Institutions offering courses in this field
            </h2>
            <CustomBadge count={institutions.length} />
          </div>
          <p>
            Select an institution to view the courses they offer. All courses
            within the selected field of study will be displayed, not just those
            that have previously required an ATAR/selection rank within your
            ATAR range. Note that many courses also have additional selection
            criteria.
          </p>
          <div id="institutions-list-container">
            {filteredInst.map((inst, i) => {
              return (
                <InstitutionLink
                  inst={inst}
                  handleClickInst={this.handleClickInst}
                  firstLink={i === 0}
                  key={inst.hepCode}
                  selectedFieldOfStudy={selectedFieldOfStudy}
                />
              );
            })}
          </div>
        </div>
        {activeInst && <UgCoursesList inst={activeInst} />}
        <div className="start-again-wrapper">
          <Button
            className="form-button--primary"
            onClick={this.handleClickStartAgain}
          >
            Start again
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { selectedFieldOfStudy } = store.selectFieldOfStudyReducer;
  const { institutions } = store.institutionsReducer;
  const { ug } = store.ugReducer;
  return {
    selectedFieldOfStudy,
    institutions,
    ug,
  };
};

export default connect(mapStateToProps)(Institutions);

// make individual component to focus on mount if first element
class InstitutionLink extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  render() {
    const { inst } = this.props;
    return (
      <button
        key={inst.key}
        className="inst-link"
        onClick={() => this.props.handleClickInst(inst)}
        ref={this.ref}
      >
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: "#15506F", marginRight: 10 }}
          className="inst-link__icon"
        />
        <div className="inst-link__text">{inst.name}</div>
      </button>
    );
  }
}
